/**
 *
 * @param items {Array} Order Items
 * @param sourceUrlsafe {String} Source UrlSafe from Product
 * @returns {Product | undefined}
 */
export const getProductFromOrderItems = (items = [], sourceUrlsafe = '') =>
  items.find((i) => i.sourceUrlsafe === sourceUrlsafe);
